

exports.__esModule = true;
exports.validationErrorMap = exports.errorElementMap = undefined;

var _squid = require('squid');

var loginRedirectUrl = (0, _squid.$getRedirectUrl)('hermes', {
    hermesLoginRedirect: 'xoon'
});

// TODO: should we have fields in a different constant
var errorElementMap = {
    INVALID_FIRST_NAME: {
        fields: [{ field: 'user.first_name' }]
    },
    INVALID_LAST_NAME: {
        fields: [{ field: 'user.last_name' }]
    },
    INVALID_PHONE_TYPE: {
        fields: [{ field: 'phone.phoneType' }]
    },
    INVALID_PHONE_NUMBER: {
        fields: [{ field: 'phone.telephone' }]
    },
    INVALID_CITY_STATE_ZIPCODE: {
        fields: [{ field: 'address.city' }, { field: 'address.state' }, { field: 'zipCode' }]
    },
    INVALID_LINE1: {
        fields: [{ field: 'address.line1' }]
    },
    INVALID_CITY: {
        fields: [{ field: 'address.city' }]
    },
    INVALID_STATE: {
        fields: [{ field: 'address.state' }]
    },
    INVALID_ZIPCODE: {
        fields: [{ field: 'PostalCode' }],
        name: 'billing'
    },
    INVALID_NATIONAL_ID_TYPE: {
        element: '#nationalIdFields',
        fields: [{ field: 'type' }],
        model: 'nationalIdModel.nationalId.'
    },
    INVALID_NATIONAL_ID: {
        element: '#nationalIdFields',
        fields: [{ field: 'Value' }],
        name: 'id'
    },
    INVALID_SECONDARY_ID_TYPE: {
        element: '#nationalIdFields',
        fields: [{ field: 'secondaryIdType' }],
        model: 'nationalIdModel.'
    },
    INVALID_SECONDARY_ID: {
        element: '#nationalIdFields',
        fields: [{ field: 'secondaryIdValue' }],
        model: 'nationalIdModel.'
    },

    INVALID_BILLING_ADDRESS: {
        element: '#billingAddress',
        name: 'billing'
    },
    INVALID_SHIPPING_ADDRESS: {
        element: '#shippingAddress',
        name: 'shipping'
    },
    INVALID_EXPIRATION_DATE: {
        element: '#expiration',
        model: 'card.',
        fields: [{ field: 'expiry_month' }, { field: 'expiry_year' }]
    },
    PASSWORD_TOO_LONG: {
        element: '#signupContainer',
        model: 'user.',
        fields: [{ field: 'password' }, { field: 'confirmPassword' }]
    },
    PASSWORD_CONTAINS_FORBIDDEN_WORDS: {
        element: '#signupContainer',
        model: 'user.',
        fields: [{ field: 'password' }, { field: 'confirmPassword' }]
    },
    PASSWORD_HAS_ILLEGAL_CHARACTERS: {
        element: '#signupContainer',
        model: 'user.',
        fields: [{ field: 'password' }, { field: 'confirmPassword' }]
    },
    ACCOUNT_ALREADY_EXISTS: {
        fields: [{ field: 'user.email' }],
        pageError: {
            contentKey: 'login.userMayHaveAccount'
        },
        compileMessageWith: {
            href: loginRedirectUrl
        },
        scrollToTop: true
    },
    INVALID_EMAIL_ID: {
        fields: [{ field: 'user.email' }]
    },
    DOB_INVALID: {
        element: '#dob, #dobBank',
        name: 'dob',
        fields: [{ field: 'Day' }, { field: 'Month' }, { field: 'Year' }, { field: 'Text' }]
    },
    REJECT_REFUSED: {
        pageError: {
            contentKey: 'creditcard.errorInstrumentRefused'
        }
    },
    INVALID_INSTRUMENT_ID: {
        pageError: {
            contentKey: 'creditcard.errorInvalidData'
        }
    },
    ADDRESS_MISMATCH: {
        pageError: {
            contentKey: 'creditcard.errorInstrumentBillingAddressNotMatch'
        }
    },
    CHECK_DIGITS_REJECTED: {
        pageError: {
            contentKey: 'creditcard.errorCheckDigits'
        }
    },
    OAS_GENERIC_ERROR: {
        pageError: {
            contentKey: 'genericError.genericError'
        },
        scrollToTop: true
    }
};

var validationErrorMap = {
    INVALID_ROUTING_NUMBER: {
        contentKey: 'bank.invalidRoutingNumber'
    },
    INVALID_ACCOUNT: {
        contentKey: 'creditcard.errorInvalidData'
    },
    ISSUER_DENIED: {
        contentKey: 'creditcard.errorIssuerDenied'
    },
    ISSUER_REJECTED: {
        contentKey: 'creditcard.errorIssuerReject'
    },
    REJECT_REFUSED: {
        contentKey: 'creditcard.errorInstrumentRefused'
    },
    INVALID_INSTRUMENT_ID: {
        contentKey: 'creditcard.errorInvalidData'
    }
};

exports.errorElementMap = errorElementMap;
exports.validationErrorMap = validationErrorMap;


_squid.$getRedirectUrl;


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/constants/errorHandlerConstants.js
// module id = ./components/xo-guest-components/src/guest/constants/errorHandlerConstants.js
// module chunks = 1